import '@fontsource-variable/outfit';
import './index.scss';

import App from './App';
import AppLDProvider from './AppLDProvider';
import { render } from './render';

const Main = () => {
  return (
    <AppLDProvider>
      <App />
    </AppLDProvider>
  );
};
void render(Main);
